import React from 'react';
import './abouttext.css'
const Abouttext = (props) => {
    return (
        <div className='abouttext-text'>
            {props.text}
        </div>
    );
};

export default Abouttext;